<template>
  <footer class="footer bxbb">
    <div :class="orgData.footer_nav.length !== 0 ? 'h100' : ''">
      <div class="container df ai-c jc-c">
        <!-- <a href="javascript:;" class="logo">
        <img src="../assets/image/logo.png" alt />
      </a> -->
        <div class="footWrap">
          <div class="footerNav" v-if="orgData.footer_nav.length">
            <div
              class="fnavItem"
              v-for="(item, ind) in orgData.footer_nav"
              :key="ind"
            >
              <a v-if="item.href" :href="compHref(item.href)" target="_blank">{{
                item.title
              }}</a>
              <span v-else>{{ item.title }}</span>
            </div>
          </div>
          <div :class="orgData.footer_nav.length ? '' : 'info'">
            <p class="copyright" v-if="website.copyright_info">
              Copyright © {{ website.copyright_info }}
            </p>
            <p class="copyright" v-else>
              Copyright © 广州冠岳网络科技有限公司 粤ICP备09217733号
            </p>
            <!-- <p class="copyright">Copyright © 2011-2021 广州冠岳网络科技有限公司版权所有</p> -->
            <!-- <div class="records">
            <span>粤公网安备44010602003224号</span>
            <span>粤ICP备09217733号</span>
            <span>粤网文[2018]1159-230号</span>
          </div> -->
          </div>
          <div class="supor">
            <a href="javascript:;" class="logo">
              <img src="../assets/image/logo.png" alt />
            </a>
            广州冠岳提供技术支持
          </div>
        </div>
      </div>
    </div>
  </footer>
</template>
<script>
import { mapGetters } from "vuex";
export default {
  name: "commonFooter",
  data() {
    return {};
  },
  mounted: function () {
    this.$nextTick(function () {
      // console.log('Dom更新后,再执行该回调');
      //设置页面主体元素最小高度：防止页面数据加载时页脚紧贴页脚
      this.setMainMinHeight();
      window.addEventListener(
        "resize",
        () => {
          this.setMainMinHeight();
        },
        false
      );
    });
  },
  methods: {
    setMainMinHeight() {
      // let root = document.documentElement || document.body,
      //   main = document.querySelector(".main");
      // let winH = root.clientHeight,
      //   headerH = document.querySelector(".header").scrollHeight,
      //   footerH = document.querySelector(".footer").scrollHeight;
      // if (main) {
      //   let mainCssStyle =
      //     window.getComputedStyle(main, null) || main.currentStyle;
      //   let mainPadTop = mainCssStyle.paddingTop,
      //     mainPadBot = mainCssStyle.paddingBottom,
      //     mainPad = parseInt(mainPadTop) + parseInt(mainPadBot);
      //   main.style.minHeight = winH - footerH - mainPad + "px";
      // }
    },
    compHref(val) {
      if (val.indexOf("http") != -1) {
        return val;
      } else {
        return "https://" + val;
      }
    },
  },
  computed: {
    ...mapGetters(["website", "orgData"]),
  },
};
</script>
<style lang="scss" scoped>
.footer {
  min-height: 76px;
  background-color: #333;
  color: #999;
  font-size: 12px;
  .h100 {
    height: 100%;
  }
  .container {
    height: 100%;
  }

  .logo {
    display: inline-block;
    width: 122px;
    height: 20px;
    margin-right: 10px;
    img {
      width: 100%;
    }
  }
  .info {
    padding-top: 11px;
  }
  .copyright {
    padding: 15px 0;
    line-height: 13px;
    text-align: center;
    font-size: 13px;
    color: #999999;
  }
  .records {
    font-size: 0;
    span {
      font-size: 12px;
      &:nth-of-type(2) {
        margin: 0 20px;
      }
      &:hover {
        color: #fff;
      }
    }
  }
  .footerNav {
    display: flex;
    justify-content: center;
    align-items: center;
    flex-wrap: wrap;
    padding-top: 15px;
    .fnavItem {
      padding: 0px 20px;
      border-left: 1px solid #999999;
      max-width: 200px;
      box-sizing: border-box;
      overflow: hidden;
      text-overflow: ellipsis;
      white-space: nowrap;
      font-size: 13px;
      line-height: 13px;
      a,
      span {
        height: 14px;
        line-height: 14px;
        color: #999;
      }
      &:first-child {
        border: none;
      }
    }
  }
  .supor {
    padding-bottom: 15px;
    display: flex;
    justify-content: center;
    font-size: 13px;
    img {
      display: block;
    }
  }
}
</style>


// WEBPACK FOOTER //
// src/components/footer.vue